"use strict";

var _objectWithoutProperties = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["mode", "name"];

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var redux_form_1 = require("redux-form");

var Box_1 = __importDefault(require("../../Box"));

var Render_1 = __importDefault(require("./Render"));

var DataArray = function DataArray(_ref) {
  var mode = _ref.mode,
      name = _ref.name,
      props = _objectWithoutProperties(_ref, _excluded);

  if (mode && 'creation' === mode) {
    return react_1.default.createElement("div", null, "array : ", name);
  }

  return react_1.default.createElement(Box_1.default, null, react_1.default.createElement(redux_form_1.FieldArray, {
    component: Render_1.default,
    name: name,
    props: props
  }));
};

exports.default = DataArray;